<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-card
            elevation="0"
            color="black"
    >
      <v-row dense justify="center">
        <div
                class="pt-5"
        >
          <v-row class="pb-2">
            <v-col class="pl-0 pt-0 pr-0" cols="2">
              <v-card  color="white" height="50px">
                <v-card-actions
                        style="height: 60px"
                >
                   <v-select
                           v-model="categorySelected"
                           v-on:change="updateSelectedCategory"
                           variant="solo"
                           label="Categorize"
                           :items="categorySmallRef"
                   ></v-select>
                </v-card-actions>
              </v-card>
            </v-col>
            <v-col class="pl-2 pr-10 pt-0" cols="2">
              <v-card  color="white" height="50px" width="200">
                <v-card-actions
                        style="height: 60px"
                >
                  <v-select
                          v-model="heroFilterChosen"
                          v-on:change="onHeroFilterChange"
                          variant="solo"
                          label="By hero name"
                          :items="heroFilterSelect"
                  ></v-select>
                </v-card-actions>
              </v-card>
            </v-col>
            <v-col>
              <ItemTabFilter
                      :pItems="tabRefs"
                      @filterChange="onTabChanged"
              >
              </ItemTabFilter>
            </v-col>
            <span class="pl-10 pb-0 pt-0 mb-3">
              <v-card  color="white" height="50px">
                <v-card-actions
                        style="height: 50px"
                >
                  <v-text-field
                          placeholder="search icon name"
                          v-model="iconSearch"
                          @input="resetOptimizeList"
                  ></v-text-field>
                  <v-btn icon>
                    <v-icon>mdi-magnify</v-icon>
                  </v-btn>
                </v-card-actions>
              </v-card>
            </span>
          </v-row>
        </div>
      </v-row>

      <v-row>
        <v-col cols="7" class="pl-7 pr-0">
          <v-virtual-scroll
            :height="this.computeWindowHeight"
            item-height="180"
            :items="this.optimizedList"
            id="item-scroller"
            >
            <template v-slot:default="{ item }">
              <div class="pa-1 ma-1">
                <v-row dense justify="center">
                  <v-col
                      v-for="it in item"
                      :key="it.name"
                  >
                    <TranformIconListCardItem
                        :pIconData="it"
                        :pFromSibling="pFromSibling"
                        @OnMarkedChange="OnMarkedChange"
                    >
                    </TranformIconListCardItem>
                  </v-col>
                </v-row>
              </div>
            </template>
          </v-virtual-scroll>
        </v-col>
        <v-col>
          <v-card
            elevation="0"
            color="black"
            :height="this.computeTransformGroupHeight"
            class="mt-1 mb-2 mr-2"
            v-if="this.transformGroupListByTotalUsed"
          >
            <v-virtual-scroll
              item-height="220"
              :items="this.transformGroupListByTotalUsed"
              id="item-scroller-transform"
              >
                <template v-slot:default="{ item }">
                  <v-card
                    elevation="1"
                    color="white"
                    class="mt-1 mb-2 mr-2"
                  >
                    <TransformIconGroupCardItem
                      :pIconGroupData="item"
                      :pHeroesIdSupport="getHeroesIdSupportIcons(item)"
                      @OnDeleteGroup="OnDeleteGroup"
                      @OnRemoveIcon="OnRemoveIcon"
                      @OnSwaped="saveTranformGroup"
                      @ToAddIcon="ToAddIcon"
                    >
                    </TransformIconGroupCardItem>
                  </v-card>
                </template>
            </v-virtual-scroll>
            <v-card
              height="50"
              class="pa-2 mt-2"
            >
              <v-row>
                <v-col 
                  v-if="markAddCounter>0"
                >
                  <v-badge
                          color="green"
                          offset-x="15"
                          offset-y="15"
                          :content="markAddCounter"
                  >
                    <v-btn color="green darken-1" text @click="doAddMarked()">Add Marded To New</v-btn>
                  </v-badge>
                </v-col>
                <v-col
                  v-if="markAddCounter==0"
                >
                  <v-btn disabled color="green darken-1" text @click="doAddMarked()">Add Marded To New</v-btn>
                </v-col>
              </v-row>
            </v-card>
          </v-card>
        </v-col>
      </v-row>
    </v-card>
</template>

<script>
    import TranformIconListCardItem from './TransformIconListCardItem';
    import ItemTabFilter from "../ItemTabFilter.vue";
    import ItemIconFileLoader from "@/item-editor/dao/ItemIconsFileLoader";
    import {GlobalEvents, EVENT_ON_ITEM_SAVED} from "@/item-editor/events/GlobalEvents";
    import {ItemCategoryNames} from "@/item-editor/constants/ItemCategories";
    import Weapon3DPackType, {Weapon3DPackTypeName, PackTypeRemoved} from "@/item-editor/constants/Weapon3DPackType";
    import WeaponAndTypeLoader from "@/item-editor/dao/WeaponAndTypeLoader";
    import HeroAndWeaponDataLoader from "@/item-editor/dao/HeroAndWeaponDataLoader";
    import EquipmentDataLoader from "@/item-editor/dao/EquipmentDataLoader";
    import ShieldDataLoader from "@/item-editor/dao/ShieldDataLoader";
    import TransformIconGroupCardItem from './TransformIconGroupCardItem';
    import HeroAndWeaponSupportUtils from "../../Utils/HeroAndWeaponSupportUtils";
    import lodash from 'lodash';

    const TabIdentifier = {
      All: "Total",
      AlreadyUsed: "Already group",
      NeverUsed: "No group"
    }
    export default {
        name: "ItemIconList",
        props:{
          'pFromSibling':{
            type: Boolean,
            default: false,
            required: false
          },
          'pCurrentName':{
            type: String,
            default: "not set",
            required: false,
          }
        },
        components: {
            TranformIconListCardItem,
            ItemTabFilter,
            TransformIconGroupCardItem
        },
        data(){
          return{
              selectedTab:null,
              totalIconList:[],
              iconListByTotalUsed: [],
              optimizedList: [],
              tabRefs: null,
              iconSearch:"",
              currentSelectName: "",
              categorySmallRef: [],
              categorySelected: "",

              heroIdFilter: -1,
              heroFilterChosen: 'ALL',
              heroFilterSelect: ['ALL', '1-Haknura', '2-Kasor', '3-Meora', '4-Reachny', '5-Visalabot', '6-Tida', '8-Soknarika', '9-Motharo'],
              refHeroAndWeaponData: [],
              refEquipmentData:[],
              refShieldData: [],
              heroAndWeaponSupportUtils: null,

              transformGroupListByTotalUsed: null,
              markAddCounter: 0,
              markIconList: []
          }
        },
        computed: {
          totalItem() {
            return this.iconListByTotalUsed.length;
          },
          computeWindowHeight() {
            const height = window.innerHeight || document.documentElement.clientHeight ||
                    document.body.clientHeight;
            return height * 0.75;
          },
          computeTransformGroupHeight(){
            const height = window.innerHeight || document.documentElement.clientHeight ||
                    document.body.clientHeight;
            return height * 0.685;
          }
        },
        methods: {
          doAddMarked(){
            let tranformIconGroupList = this.$store.state.tranformIconGroupList;
            let groupIdNew = tranformIconGroupList.length + 1;
            if(confirm(`Do you want add ${this.markAddCounter} marked to new groupId: ${groupIdNew}?`)){
              let iconsNew = [];
              let category = '';
              this.markIconList.forEach(icon => {
                if(category == ''){
                  category = icon.categoryRefType;
                }
                iconsNew.push(icon.name);
              });
              tranformIconGroupList.push({
                groupId: groupIdNew,
                icons: iconsNew,
                category: category
              });

              this.ClearMarked();
              this.saveTranformGroup();
              this.resetGroupIconsList();
            }
          },

          ClearMarked(){
            this.markIconList.forEach(icon => {
              icon.isMark = false;
            });
            this.markAddCounter = 0;
          },
          OnMarkedChange(){
            this.markIconList = this.totalIconList.filter(icon => icon.isMark);
            this.markAddCounter = this.markIconList.length;
          },

          OnDeleteGroup(groupId){
            if(confirm(`Do you want delete groupId: ${groupId}?`)){
                   let tranformIconGroupList = this.$store.state.tranformIconGroupList;
                   let group = tranformIconGroupList.find(g => g.groupId == groupId);
                   if(group){
                      /*not remove icon from list
                      group.icons.forEach(ic =>{
                        let iconData = this.totalIconList.find(iconData => iconData.name == ic);
                        if(iconData){
                          iconData.groupId = -1;
                        }
                      });
                      group.icons = [];*/
                      group.isRemoved = true;
                      this.saveTranformGroup();
                      this.resetGroupIconsList();
                   }
              }
          },
          OnRemoveIcon(payload){
            const {groupId, iconName} = payload;
             if(confirm(`Do you want remove ${iconName} from groupId: ${groupId}?`)){
                   let tranformIconGroupList = this.$store.state.tranformIconGroupList;
                   let group = tranformIconGroupList.find(g => g.groupId == groupId);
                   if(group){
                      let index = group.icons.indexOf(iconName);
                      group.icons.splice(index, 1);
                      let iconData = this.totalIconList.find(iconData => iconData.name == iconName);
                      if(iconData){
                        iconData.groupId = -1;
                      }
                      /*dont remove group
                      if(group.icons.length === 0){
                        group.isRemoved = true;
                      }*/
                      this.saveTranformGroup();
                      this.resetGroupIconsList();
                   }
              }
          },
          saveTranformGroup(){
            this.$store.commit(this.$store.state.commitActions.PUSH_TRANFORM_ICON_GROUP);
          },
          ToAddIcon(groupId){
            if(confirm(`Do you want add ${this.markAddCounter} marked to groupId: ${groupId}?`)){
              let tranformIconGroupList = this.$store.state.tranformIconGroupList;
              let iconGroup = tranformIconGroupList.find(group => group.groupId == groupId);
              this.markIconList.forEach(icon => {
                  if(iconGroup.icons.length === 0){
                    iconGroup.category = icon.categoryRefType;
                  }
                  iconGroup.icons.push(icon.name);
              });
              
              this.ClearMarked();
              this.saveTranformGroup();
              this.resetGroupIconsList();
            }
          },

          onTabChanged(tab) {
            this.iconListByTotalUsed = [];
            if (tab.id === TabIdentifier.All){
              this.totalIconList.forEach(icon =>{
                if(this.getPassCategorize(icon)){
                  this.iconListByTotalUsed.push(icon);
                }
              });
              //this.iconListByTotalUsed = this.totalIconList;
            }else if (tab.id === TabIdentifier.AlreadyUsed){
              this.totalIconList.forEach(icon =>{
                if(this.getPassCategorize(icon)){
                  if(icon.groupId > 0){
                    this.iconListByTotalUsed.push(icon);
                  }
                }
              });
              //this.iconListByTotalUsed = this.totalIconList.filter(icon => icon.totalUsed > 0);
            }else if (tab.id === TabIdentifier.NeverUsed){
              this.totalIconList.forEach(icon =>{
                if(this.getPassCategorize(icon)){
                  if(!icon.groupId || icon.groupId <= 0){
                    this.iconListByTotalUsed.push(icon);
                  }
                }
              });
              //this.iconListByTotalUsed = this.totalIconList.filter(icon => !icon.totalUsed || icon.totalUsed <= 0);
            }

            //filter by hero id
            if(this.heroIdFilter > -1){
              this.iconListByTotalUsed = this.iconListByTotalUsed.filter((icon) => {
                return this.supportedHeroes(this.heroIdFilter, icon)
              });
            }

            this.refreshTabTitle();
            this.selectedTab = tab;

            this.resetOptimizeList();
          },
          resetOptimizeList(){
            this.optimizedList = [];
            setTimeout(() => {
              this.generateOptimizeList();
            }, 300);
          },
          getPassCategorize(icon){
            if(this.categorySelected !== this.categorySmallRef[0]){
              icon.showOnCategory = icon.categoryRefType === this.categorySelected;
              return icon.showOnCategory;
            }
            icon.showOnCategory = this.categorySelected === this.categorySmallRef[0];
            return icon.showOnCategory;
          },
          async refreshTotalUsed() {
            let tranformIconGroupList = this.$store.state.tranformIconGroupList;
            this.totalIconList.forEach(icon => {
              let groupIcons = tranformIconGroupList.find(iconGroup => {
                return iconGroup.icons.includes(icon.name);
              });
              if (groupIcons){
                icon.groupId = groupIcons.groupId;

                /*set category
                if(!groupIcons.category){
                  groupIcons.category = icon.categoryRefType;
                }*/
              }
            });

            //save when category setted
            //this.saveTranformGroup();
          },
          setCurrentSelect(index){
            setTimeout(() => {
              let itemHeight = 180; // set as appropriate
              let scrollH = itemHeight * index;
              document.getElementById("item-scroller").scrollTop = scrollH;
            }, 300);

          },
          initTabRef () {
            this.iconListByTotalUsed = [];
            this.totalIconList.forEach(icon =>{
              icon.showOnCategory = true;
              this.iconListByTotalUsed.push(icon);
            });
            this.refreshTabTitle();
            this.selectedTab = this.tabRefs[0];
            this.generateOptimizeList(true);
          },

          initTranformGroup () {
            this.transformGroupListByTotalUsed = [];
            let tranformIconGroupList = this.$store.state.tranformIconGroupList;
            tranformIconGroupList.forEach(iconGroup =>{
              //if(iconGroup.isRemoved) return;
              this.transformGroupListByTotalUsed.push(iconGroup);
            });
          },
          async resetGroupIconsList(){
            await this.refreshTotalUsed();
            this.initTranformGroup();
            this.refreshTabTitle();
            this.resetOptimizeList();
          },

          refreshTabTitle () {
            let iconList = [];
            this.totalIconList.forEach(icon =>{
              if(icon.showOnCategory){
                iconList.push(icon);
              }
            });
            let alreadyUsed = iconList.filter(icon => icon.groupId > 0);
            let neverUsed = iconList.filter(icon => !icon.groupId || icon.groupId <= 0);
            this.tabRefs = [
              {"title":TabIdentifier.All + ` (${iconList.length})`, "id":TabIdentifier.All},
              {"title":TabIdentifier.AlreadyUsed + ` (${alreadyUsed.length})`, "id":TabIdentifier.AlreadyUsed},
              {"title":TabIdentifier.NeverUsed + ` (${neverUsed.length})`, "id":TabIdentifier.NeverUsed},
            ];
          },
          isIconNameOnCategory(name, cat) {
            let passCount = 0;
            if (ItemCategoryNames.potion.includes(cat)) {
              passCount += (name.includes('potion') || name.includes('inventory_00')) ? 1 : 0;
            }
            if (ItemCategoryNames.ring.includes(cat)) {
              passCount += (name.includes('ring')) ? 1 : 0;
            }
            if (ItemCategoryNames.scroll.includes(cat)) {
              passCount += (name.includes('spell')) ? 1 : 0;
            }
            if (ItemCategoryNames.glove.includes(cat)) {
              passCount += (name.includes('group-18') || name.includes('claw'))? 1 : 0;
            }
            if (ItemCategoryNames.shield.includes(cat)) {
              passCount += (name.includes('group-4')) || name.includes('sh2d') ? 1 : 0;
            }
            return passCount > 0;
          },
          updateSelectedCategory(){
            this.onTabChanged(this.selectedTab);
          },
          onHeroFilterChange() {
            this.heroIdFilter = -1;
            if (this.heroFilterChosen !== '' && this.heroFilterChosen !== 'ALL') {
              if (this.heroFilterSelect.includes(this.heroFilterChosen)) {
                this.heroIdFilter = Number.parseInt(this.heroFilterChosen.split('-')[0]);
              }
            }
            this.onTabChanged(this.selectedTab);
          },
          removeHeroFilterChosen (item) {
            if(this.heroFilterChosen === item){
              this.heroFilterChosen = '';
            }
            this.onHeroFilterChange();
          },
          supportedHeroes (heroId, iconData) {
            if (iconData.category === 'weapon' || iconData.category === 'glove') {
              let equipmentCode = this.getEquipmentCodeByWeaponName(iconData.name);
              if (equipmentCode > -1) {
                let refHero = this.refHeroAndWeaponData.find(ref => ref.heroId === heroId);
                let code = parseInt(equipmentCode);
                if (refHero.weaponIds.includes(code)) {
                  return true;
                }
                return false;
              } else {
                return true;
              }
            } else {
              return true;
            }
          },
          getHeroesIdSupportIcon(iconName) {
            let iconData = this.totalIconList.find(i => i.name == iconName);
            return this.heroAndWeaponSupportUtils.heroesWhoCanUseIcon(iconData);
          },
          getHeroesIdSupportIcons(iconGroup){
            let heroIdsList = {};
            iconGroup.icons.forEach(icon => {
              heroIdsList[icon] = this.getHeroesIdSupportIcon(icon);
            });
            return heroIdsList;
          },
          getEquipmentCodeByWeaponName(weaponName){
            let weaponId = -1;
            let foundInWeapon = this.refEquipmentData.find(ref => ref.weaponName+".png" === weaponName);
            if (foundInWeapon) {
              weaponId = foundInWeapon.weaponId;
            }
            else {
              let foundInShield = this.refShieldData.find(ref => ref.weaponName+".png" === weaponName);
              if (foundInShield) {
                weaponId = foundInShield.weaponId;
              }
            }
            return weaponId;
          },

          generateOptimizeList(isMoveToSelect){
            let toDisplay = this.iconListByTotalUsed;

            if(this.iconSearch){
              let iconSearchLowerCase = this.iconSearch.toLowerCase();
              toDisplay = toDisplay.filter((icon) => {
                let iconNameLowerCase = icon.name.toLowerCase();
                let isPassCategory = this.isIconNameOnCategory(iconNameLowerCase, iconSearchLowerCase);
                let isPassName = iconNameLowerCase.includes(iconSearchLowerCase);
                return isPassCategory || isPassName;
              });
            }

            toDisplay.sort((a, b) => {

              if (!a.groupId && !b.groupId) {
                if (a.name > b.name) return 1;
              }

              if (!a.groupId) return -1;
              if (!b.groupId) return 1;

              if (a.groupId > b.groupId) return 1;
              else return -1;
            });
            let optimizedList = [];
            let rowCount = 1;

            let tempRow = [];
            for (let i = 0; i < toDisplay.length; i++) {
              tempRow.push(toDisplay[i]);

              toDisplay[i].isCurrentSelect = this.currentSelectName === toDisplay[i].name;
              if(toDisplay[i].isCurrentSelect && isMoveToSelect){
                this.setCurrentSelect(optimizedList.length);
              }

              if (rowCount === 6 || i === toDisplay.length - 1) {
                optimizedList.push(tempRow);
                rowCount = 0;
                tempRow = [];
              }
              rowCount++;
            }

            this.optimizedList = optimizedList;
          },
          toFixIconRef(){
            console.log('origin',this.refHeroAndWeaponData);
            let cloneIconRef = lodash.cloneDeep(this.refHeroAndWeaponData);
            this.transformGroupListByTotalUsed.forEach(item=>{
              let rootHeroIds = this.getHeroesIdSupportIcon(item.icons[0]);              
              for(let i=1;i<item.icons.length;i++){
                let icon = item.icons[i];
                let weaponId = "";
                let iconCleanName = icon.replace(".png", "");
                let foundInWeapon = this.refEquipmentData.find(ref => ref.weaponName === iconCleanName);
                if (foundInWeapon) {
                    weaponId = foundInWeapon.weaponId;
                }
                else {
                    let foundInShield = this.refShieldData.find(ref => ref.weaponName === iconCleanName);
                    if (foundInShield) {
                        weaponId = foundInShield.weaponId;
                    }
                }
                if (weaponId){
                    let heroeIds = [];
                    this.refHeroAndWeaponData.forEach(hd => {
                        let code = parseInt(weaponId);
                        if (hd.weaponIds.includes(code)){
                            heroeIds.push(hd.heroId);
                        }
                    });

                    //remove
                    heroeIds.forEach(h => {
                      if(!rootHeroIds.includes(h)){
                        //count--;
                        let iconRef = cloneIconRef.find(hd => hd.heroId == h);
                        let index = iconRef.weaponIds.indexOf(weaponId);
                        iconRef.weaponIds.splice(index, 1);
                      }
                    });
                    //add
                    rootHeroIds.forEach(h => {
                      if(!heroeIds.includes(h)){
                        let iconRef = cloneIconRef.find(hd => hd.heroId == h);
                        iconRef.weaponIds.push(weaponId);
                      }
                    });
                }
              }
            });
            console.log('cloneIconRef', cloneIconRef);
          }
        },

        created() {
          GlobalEvents.$on(EVENT_ON_ITEM_SAVED, ()=> {
            this.refreshTotalUsed().then(()=>{
              this.iconListByTotalUsed = [];
              this.onTabChanged(this.selectedTab);
            });

          });
        },

        async beforeCreate() {
          this.totalIconList= await ItemIconFileLoader.loadIconRefData();

          let refWeaponAndTypeData = await WeaponAndTypeLoader.loadData();

          this.totalIconList.forEach(icon => {
            let weaponData = refWeaponAndTypeData.find(r => {
              return r.weaponName+".png" === icon.name;
            });
            if(weaponData) {
              icon.categoryRefType = Weapon3DPackType[weaponData.weapon3DPackType];
              icon.category = Weapon3DPackTypeName[icon.categoryRefType];
            }
            icon.isMark = false;
          });

          this.currentSelectName = this.pCurrentName+".png";

          this.categorySmallRef = [];
          this.categorySmallRef.push('ALL');
          Weapon3DPackType.forEach(ref =>{
            if(!PackTypeRemoved.includes(ref)){
              this.categorySmallRef.push(ref);
            }
          });
          this.categorySelected = this.categorySmallRef[0];

          this.refEquipmentData = await EquipmentDataLoader.loadData();
          this.refHeroAndWeaponData = await HeroAndWeaponDataLoader.loadData();
          this.refShieldData = await ShieldDataLoader.loadData();
          this.heroAndWeaponSupportUtils = new HeroAndWeaponSupportUtils(this.refHeroAndWeaponData, this.refEquipmentData, this.refShieldData);

          await this.refreshTotalUsed();
          this.initTranformGroup();
          this.initTabRef();

          //to enable to fix icon equip rule, and take it to replace on heroAndWeaponDatas.json both front end and game play
          //this.toFixIconRef();
        },
    }
</script>